import { Link, Typography } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";
import { useFilterPanelsState } from "@/shared/modules/GameFilters/useFilterPanels";
import { dispatchCustomEvent } from "@/global/utils/dispatchCustomEvent";
import { customEvents, filterPanelNames } from "../../constants";
import { useNoInventoryAlertModal } from "@/shared/modules/PurchaseSeats/ChooseSeats/force-event-selection/NoInventoryAlertModal";
import { throttleTime } from "@/global/utils/utils";

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager",
    description:
      "Connect your New Jersey Devils account using our secure Ticketmaster login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Games",
    description:
      "Select the games you wish to attend based on the amount of credit you have available.",
  },

  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available by logging into your New Jersey Devils{" "}
        <Link
          href={"https://am.ticketmaster.com/devils/"}
          target={"_blank"}
          sx={{
            color: "primary.main",
            textDecoration: "none",
            fontWeight: 500,
          }}
        >
          Account Manager
        </Link>{" "}
        in early September 2025. Reach out to Live Fan Support for any
        questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the New Jersey Devils Flex work?",
    description:
      "The New Jersey Devils Flex allows fans to select any seat to any game. Simply log into your New Jersey Devils Account Manager and select games.",
  },
  {
    title: "Do I have to select all my games now?",
    description:
      "No, you do not have to select all your games at once. Feel free to return at any point throughout the season to continue to use your credit.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all current available inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description:
      "Event tickets will be delivered directly within your New Jersey Devils Account Manager in early September, 2025.",
  },
];

export function CheckoutTerms() {
  return (
    <>
      By purchasing you agree to receive SMS alerts regarding ticket delivery
      and agree to the{" "}
      <Link
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
        href="https://www.attend.tech/terms-of-use"
      >
        Terms of Use
      </Link>{" "}
      and{" "}
      <Link
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
        href="https://www.attend.tech/privacy-policy"
      >
        Privacy Policy
      </Link>
      .
    </>
  );
}

export function NoInventoryModalDescription() {
  const { lastChangedFilter } = useFilterPanelsState();
  const noInventoryModal = useNoInventoryAlertModal();

  const openLastChangedFilterPanel = () => {
    dispatchCustomEvent(customEvents.openGameFilter, {
      name: lastChangedFilter || filterPanelNames.seat_counter,
    });
    noInventoryModal.onFinish({ action: "tryAgain" });
    noInventoryModal.set({ isOpen: false });
    throttleTime(400, () => noInventoryModal.reset());
  };

  return (
    <Typography variant="body1">
      It looks like this event is running low on inventory. Please try adjusting
      the{" "}
      <Link
        className="global-link"
        fontWeight={"500"}
        onClick={openLastChangedFilterPanel}
      >
        filters.
      </Link>
    </Typography>
  );
}
